<div class="header">
  <div>
    <cerrix-title [text]="title"></cerrix-title>
  </div>
  <div>
    <cerrix-subtitle [text]="subTitle"></cerrix-subtitle>
  </div>
</div>
